import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { CURICULUM_SUBJECT_LIST, CURICULUM_TOOL_PROVIDER } from '@/utils/constants';
import { sessionService } from '@/providers/services/auth/session';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import SuperUserTool from './super-user-tool/super-user-tool';
import DistrictDataLake from './district-level/district-data-tool';
import SubjectBasedTool from './subject-based-tool/subject-based-tool';
import axios from 'axios';
@Component({
    name: 'data-lake',
    components: {
        'material-icons': GoogleMaterialIcon,
        'super-user-tool': SuperUserTool,
        'district-data-tool': DistrictDataLake,
        'subject-based-tool': SubjectBasedTool,
    },
})

export default class DataLake extends Vue {

    // ----------------------------------------------------------
    // Properties
    get isSuperAdmin() {
        return this.$access.hasPermission(this.$access.menus.all, this.$access.ACL.all);
      }

    private imageList: any = {
        screen1: this.$access.hasMenuAccess('all') ? 'gooru' : 'tenant',
        screenmath: 'math',
        screen2: '2',
        screen3: '3',
        screen4: '4',
    };

    private style: any = {};

    private popupStyle: any = {};

    private activeScreen: string = this.imageList.screen1;

    private isShowPop: boolean = false;

    private subjectList: any = CURICULUM_SUBJECT_LIST;

    private toolProvider: any = [];

    private activeSubject: string = 'All';

    private session: any = sessionService.getSession();

    private toolProviderBySubjects: any = [];

    private tableData: any = [
        {
            application: 'Power BI',
            provider: 'Eureka Math, Lexia, SCALE',
            subject: 'Math, Science, ELA',
            grade: '6-12',
            time: 'Last one year',
            event: '2.6M events <br> 18 May 2020',
        },
        {
            application: 'Navigator',
            provider: 'All',
            subject: 'All',
            grade: 'K-12',
            time: 'All',
            event: '10M events <br> 20 July 2020',
        },
        {
            application: 'Educational MIS',
            provider: 'All',
            subject: 'All',
            grade: 'K-12',
            time: 'Last one year',
            event: '3.8M events <br> 20 July 2020',
        },
    ];

    // --------------------------------------------------------------
    // Hooks

    private created() {

        this.fetchProviderList();
    }

    private mounted() {
        this.onChangeImage(this.imageList.screen1);
    }


    // ------------------------------------------------------------------
    // Actions

    private onChangeImage(imgName: string) {
        this.activeScreen = imgName;
        this.isShowPop = false;
        const url = this.parseImageUrl(imgName);
        this.$set(this.style, 'background-image', `url(${url})`);
        this.loadImage(url, this.style);
    }

    // ------------------------------------------------------------------------
    // methods

    private parseImageUrl(imgName: string) {
        return `/img/default-images/partner-data-lake/screen${imgName}.png`;
    }

    private loadImage(url: string, style: any) {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            this.$set(style, 'height', img.height + 'px');
            if (this.isShowPop) {
                this.$set(style, 'width', img.width + 'px');
            }
        };
    }


    private onShowPop(imgName: string) {
        this.isShowPop = true;
        this.activeScreen = imgName;
        const url = this.parseImageUrl(imgName);
        this.$set(this.popupStyle, 'background-image', `url(${url})`);
        this.loadImage(url, this.popupStyle);
    }

    private onSelectSubject(subject: string) {
        this.activeSubject = subject;
        this.toolProviderBySubjects = this.toolProvider.filter((provider: any) => provider.subject === subject);
    }

    private loadCuriculumProvider() {
        return dataLakeAPI.fetchCuriculumProvider(this.$access.isHighContrastEnable);
    }

    private fetchProviderList() {
        axios.all([this.loadCuriculumProvider()]).then(axios.spread(
            (provider: any) => {
                this.toolProvider = provider;
            }),
        );
    }

}
